// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2abdca91","453":"38208c36","455":"180cbc95","977":"0a4efcd1"}[chunkId] + ".chunk.js";
};